import { Popover } from 'antd'

import type { ReactNode } from 'react'

import { CssIcon } from '@/components/CssIcon'

interface InfoPopoverProps {
  content: ReactNode
  iconClassName?: string
  maxWidth?: number
}

export default function InfoPopover({
  content,
  iconClassName,
  maxWidth = 320,
}: InfoPopoverProps) {
  return (
    <Popover
      classNames={{
        root: cls`border-f-border overflow-hidden rounded-lg border`,
      }}
      styles={{
        body: { maxWidth: `min(${maxWidth}px, 90vw)` },
      }}
      content={<div className={cls`text-f-text-secondary`}>{content}</div>}
    >
      <CssIcon
        className={cls`i-com--info text-f-text-quaternary size-4 ${iconClassName || ''}`}
      />
    </Popover>
  )
}
